var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 24,
  viewBox: "0 0 36 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3879",
  "data-name": "Group 3879",
  transform: "translate(-539 -71)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2543",
  "data-name": "Rectangle 2543",
  width: 36,
  height: 24,
  rx: 2,
  transform: "translate(539 71)",
  fill: "#fff",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3877",
  "data-name": "Group 3877",
  transform: "translate(1785.391 698)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3872",
  "data-name": "Group 3872",
  transform: "translate(-1239.891 -621)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_113",
  "data-name": "Path 113",
  d: "M-193-766.254h4.7",
  transform: "translate(193 771.873)",
  fill: "none",
  stroke: "#2a9c27",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Subtraction_1",
  "data-name": "Subtraction 1",
  transform: "translate(4.53 0)",
  fill: "#2a9c27"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 5.598378658294678 11.46543502807617 C 4.281162738800049 11.32049655914307 3.065618515014648 10.75135135650635 2.130898952484131 9.833738327026367 C 1.079198837280273 8.801248550415039 0.4999988377094269 7.439968109130859 0.4999988377094269 6.00065803527832 C 0.4999988377094269 4.560758113861084 1.079208850860596 3.199058055877686 2.130938768386841 2.166388034820557 C 3.066044330596924 1.248249292373657 4.282218456268311 0.6789766550064087 5.598378658294678 0.5343954563140869 L 5.598378658294678 11.46543502807617 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 5.098378658294678 10.87892913818359 L 5.098378658294678 1.121057748794556 C 4.108504772186279 1.333351731300354 3.202873229980469 1.814628481864929 2.481238842010498 2.523158073425293 C 1.526048898696899 3.461048126220703 0.9999988675117493 4.696038246154785 0.9999988675117493 6.00065803527832 C 0.9999988675117493 7.304667949676514 1.526028871536255 8.539237976074219 2.481178760528564 9.476938247680664 C 3.202846765518188 10.18540668487549 4.108519077301025 10.66665363311768 5.098378658294678 10.87892913818359 M 6.098378658294678 11.99997806549072 L 6.096758842468262 11.99992847442627 C 4.459249019622803 11.95794773101807 2.926418781280518 11.31536769866943 1.780628800392151 10.19053840637207 C 0.6323688626289368 9.063258171081543 -1.14768977255153e-06 7.575258255004883 -1.14768977255153e-06 6.00065803527832 C -1.14768977255153e-06 4.425467967987061 0.6323688626289368 2.937067985534668 1.780628800392151 1.80961811542511 C 2.926758766174316 0.6842880845069885 4.460158824920654 0.04162807762622833 6.098378658294678 -1.920928980325698e-06 L 6.098378658294678 11.99997806549072 Z",
  stroke: "none",
  fill: "#2a9c27"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3873",
  "data-name": "Group 3873",
  transform: "translate(-1228.031 -621)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_114",
  "data-name": "Path 114",
  d: "M-188.3-766.254H-193",
  transform: "translate(199.438 771.873)",
  fill: "none",
  stroke: "#2a9c27",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Subtraction_2",
  "data-name": "Subtraction 2",
  transform: "translate(6.098 12) rotate(180)",
  fill: "#2a9c27"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 5.598378658294678 11.46558094024658 C 4.282217979431152 11.32100009918213 3.066042900085449 10.7517261505127 2.130928516387939 9.833578109741211 C 1.079208612442017 8.800918579101562 0.4999985992908478 7.439218521118164 0.4999985992908478 5.999318599700928 C 0.4999985992908478 4.560008525848389 1.079198598861694 3.198728561401367 2.130908727645874 2.16623854637146 C 3.066070318222046 1.248182415962219 4.282246589660645 0.6789416074752808 5.598378658294678 0.5343981385231018 L 5.598378658294678 11.46558094024658 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 5.098378658294678 1.121047973632812 C 4.108519554138184 1.333322525024414 3.2028489112854 1.814569473266602 2.481188535690308 2.523038864135742 C 1.526028633117676 3.460738182067871 0.9999985694885254 4.695308685302734 0.9999985694885254 5.999318599700928 C 0.9999985694885254 7.303938388824463 1.52604866027832 8.538928985595703 2.481228590011597 9.476808547973633 C 3.20287036895752 10.18534564971924 4.108504295349121 10.66662406921387 5.098378658294678 10.87891864776611 L 5.098378658294678 1.121047973632812 M 6.098378658294678 -1.9073486328125e-06 L 6.098378658294678 11.99997901916504 C 4.460158348083496 11.95834827423096 2.926758527755737 11.31568813323975 1.780628681182861 10.19035816192627 C 0.6323685646057129 9.062908172607422 -1.430511474609375e-06 7.574508666992188 -1.430511474609375e-06 5.999318599700928 C -1.430511474609375e-06 4.424718379974365 0.6323685646057129 2.936718940734863 1.780628681182861 1.809438705444336 C 2.926418542861938 0.6846084594726562 4.459248542785645 0.04202842712402344 6.096758842468262 4.863739013671875e-05 L 6.098378658294678 -1.9073486328125e-06 Z",
  stroke: "none",
  fill: "#2a9c27"
})))))));
export default __webpack_public_path__ + "static/media/connectedStore.a1fe7056.svg";
export { SvgComponent as ReactComponent };